module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "validateEmail"
    }
  }, [_c('Background-Image', {
    attrs: {
      "url": "surf-sun.jpg",
      "lowResUrl": "surf-sun-lowres.jpg",
      "color": "#0288D1"
    }
  }), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "ValidationSuccessful"
    }
  }, [_c('div', {
    staticClass: "row p-t-5"
  }, [_c('div', {
    staticClass: "offset-md-3 col-md-6"
  }, [(_vm.confirmed) ? _c('div', {
    staticClass: "m-t-6 card text-xs-center"
  }, [_c('div', {
    staticClass: "card-header success-color-dark white-text"
  }, [_vm._v("\n            " + _vm._s(_vm.t('Registration')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.t('Email has been confirmed')))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.t('Your account is now active')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "id": "registrationSuccessClose"
    },
    on: {
      "click": _vm.redirectToLogin
    }
  }, [_vm._v("Login")])])]) : _vm._e(), _vm._v(" "), (_vm.confirmed === false) ? _c('div', {
    staticClass: "m-t-6 card text-xs-center"
  }, [_c('div', {
    staticClass: "card-header default-color-dark white-text"
  }, [_vm._v("\n          Account Registration\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("There was an error confirming your email")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "id": "registrationSuccessClose"
    },
    on: {
      "click": _vm.redirectHome
    }
  }, [_vm._v("Home")])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "m-t-6 card text-xs-center"
  }, [_c('div', {
    staticClass: "card-header default-color-dark white-text"
  }, [_vm._v("\n        Account Registration\n      ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "card-text"
  }, [_vm._v("If you need assistance please contact us"), _c('br'), _vm._v("at info@booknatura.com")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-circle-o-notch",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Validating your account...")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": "",
      "id": "registrationSuccessClose"
    }
  }, [_vm._v("Login")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-63c3a9e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c3a9e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/ValidateEmail.vue
// module id = 783
// module chunks = 3